import { ContentPage } from "./ContentPage";
import { PLATFORM } from "../../config/platform";

// Reusable content body — used both on the public page and the in-app
// (Settings → Privacy Policy) screen.
export const PrivacyBody = () => (
  <>
    <p>
      This Privacy Policy explains how {PLATFORM.platform_name} collects, uses and protects
      your information when you use our platform. By using the service you agree
      to the practices described here.
    </p>

    <h2>Information we collect</h2>
    <ul className="list-disc">
      <li>Account details: name, email, phone and organization information.</li>
      <li>Operational data you enter: products, customers, orders and more.</li>
      <li>Usage and device information to keep the service secure and reliable.</li>
    </ul>

    <h2>How we use your information</h2>
    <ul className="list-disc">
      <li>To provide, maintain and improve the platform.</li>
      <li>To authenticate users and protect against abuse.</li>
      <li>To communicate important service and account updates.</li>
    </ul>

    <h2>Data security</h2>
    <p>
      We use industry-standard safeguards including encrypted credentials and
      access controls. Your organization's data is isolated per account.
    </p>

    <h2>Your choices</h2>
    {/* "30 days" below is prose, not fetched from AppConfig.accountDeletionGraceDays
        (that query requires auth). If a platform owner changes the configured
        grace period in Settings, update this text and mobileapp's copy of it. */}
    <p>
      You can delete your own account at any time — sign in, go to{" "}
      <strong>Profile</strong>, and select <strong>Delete my account</strong>{" "}
      under the "Danger zone" section (mobile app: Settings →{" "}
      <strong>Account Settings</strong>). This is a soft delete: your account
      is scheduled for deletion after a grace period (30 days by default —
      your platform administrator can adjust this), during which you can
      restore it at any time simply by signing back in and selecting{" "}
      <strong>Restore my account</strong>. Once the grace period elapses, your
      account is permanently deactivated.
    </p>
    <p>
      If you're the sole owner of an organization with other members, you'll
      be asked to transfer ownership to another member before your account
      can be deleted — this protects your team from losing access to their
      own organization. If you're the only member of your organization, it
      will be deleted along with your account.
    </p>
    <p>
      See{" "}
      <a href="/delete-account">{PLATFORM.domain}/delete-account</a> for
      full details, or if you can't sign in, request deletion by emailing{" "}
      <a href={`mailto:${PLATFORM.support.privacy_email}`}>
        {PLATFORM.support.privacy_email}
      </a>
      .
    </p>
  </>
);

export const Privacy = ({ onBack }: { onBack: () => void }) => (
  <ContentPage title="Privacy Policy" onBack={onBack}>
    <PrivacyBody />
  </ContentPage>
);

export default Privacy;
